import { NgModule } from '@angular/core'

import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { conversationReducer } from '@flowx/designer/modules/ai/conversation/conversation.reducer'
import { MEDIA_LIBRARY_API } from '@flowx/designer/modules/core/dictionary/media-library.dictionary'
import { MediaLibraryPrivateApi } from '@flowx/designer/shared/api/media-library-private.api'
import { MediaLibraryService } from '@flowx/designer/shared/services/media-library.service'

import { aiFeatureKey, conversationFeatureKey } from './ai.constants'
import { AiEffects } from './ai.effects'
import { aiReducer } from './ai.reducer'

import { AiAnalystEffects } from '../agents/analyst/store/analyst.effects'
import { AiArchitectEffects } from '../agents/architect/store/architect.effects'
import { AiAssistantEffects } from '../agents/assistant/store/assistant.effects'
import { AiDesignerEffects } from '../agents/designer/store/designer.effects'
import { DeveloperEffects } from '../agents/developer/store/developer.effects'
import { ConversationErrorEffects } from '../conversation/conversation-error.effects'
import { ConversationNavigationEffects } from '../conversation/conversation-navigation.effects'
import { ConversationEffects } from '../conversation/conversation.effects'

@NgModule({
  imports: [
    StoreModule.forFeature(aiFeatureKey, aiReducer),
    StoreModule.forFeature(conversationFeatureKey, conversationReducer),
    EffectsModule.forFeature(
      AiEffects,
      AiAssistantEffects,
      AiAnalystEffects,
      AiArchitectEffects,
      AiDesignerEffects,
      ConversationEffects,
      ConversationErrorEffects,
      DeveloperEffects,
      ConversationNavigationEffects
    ),
  ],
  providers: [
    { provide: MEDIA_LIBRARY_API, useClass: MediaLibraryPrivateApi },
    MediaLibraryService,
  ],
})
export class AiStoreModule {}
